var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { filterOrganizationTreeItems, organizationEntityName, orgTreePublicDataKey, resolveOrgTreeItemIdsDef, } from '../../../../backend/features/organizations/shared';
import { filterOrganizationTreeItemsByFieldFilter } from '../../../../ui/features/organizations/components/OrganizationsPanel/utils/filterOrganizationTreeItemsByFieldFilter';
import { useTypedAnonymousPlatformFunctionCM } from '../../../../ui/hooks/useTypedAnonymousPlatformFunction';
import { useDataTreeUsingState } from '@juvare/common-data-table-ui/DataTree';
import { usePublicDataGet } from '@juvare/platform-sdk-react/ui/hooks/usePublicDataGet';
import { getAppName } from '@juvare/platform-sdk-react/ui/utils';
import React from 'react';
import { mapOrganizationFilterData } from './useOrganizationsTree';
export function useOrganizationsSelectionTreeAnonymous({ useDataTreeFunction = useDataTreeUsingState, initialSelectedOrganizationIds, filteredOrganizationsIds, }) {
    var _a;
    const orgTree = React.useRef([]);
    const resolvedAnonymousTreeItem = useTypedAnonymousPlatformFunctionCM(resolveOrgTreeItemIdsDef, getAppName(), organizationEntityName);
    const params = {
        useDataProvider: (request) => {
            const { data: organizationsTreeData, isLoading, error, mutate, } = usePublicDataGet(orgTreePublicDataKey);
            const data = React.useMemo(() => {
                const selectedOrganizations = filterOrganizationTreeItems(organizationsTreeData !== null && organizationsTreeData !== void 0 ? organizationsTreeData : [], (item) => {
                    if (filteredOrganizationsIds) {
                        return filteredOrganizationsIds === null || filteredOrganizationsIds === void 0 ? void 0 : filteredOrganizationsIds.includes(item.id.split('_')[0]);
                    }
                    return true;
                });
                // Apply any filters
                const filterResult = filterOrganizationTreeItemsByFieldFilter(selectedOrganizations, mapOrganizationFilterData({ search: request.filterData.search }));
                orgTree.current = filterResult.organizations;
                return {
                    items: filterResult.organizations,
                    highlightedItemIds: filterResult.highlightedOrganizationIds,
                };
                // eslint-disable-next-line react-hooks/exhaustive-deps
            }, [request.filterData.search, filteredOrganizationsIds, initialSelectedOrganizationIds, organizationsTreeData]);
            return {
                data,
                error: error,
                reload: () => mutate,
                isLoading: isLoading,
            };
        },
    };
    const { dataTreeProps, filtersBarProps, appliedFilterData, reload } = useDataTreeFunction(Object.assign(Object.assign({}, params), { initialSelectedItemIds: initialSelectedOrganizationIds }));
    // DO NOT TRY TO COPY THIS APPROACH. This is not an ideal solution. This is done so that we don't have to load
    // preselected values in every other library that uses this hook,
    // requiring developers to know that they must load them in addition to passing them to this hook.
    // TODO remove after CUI-532
    const { onChangeSelectedItemIds } = dataTreeProps;
    React.useEffect(() => {
        function fetchResolvedAnonymousTreeItemIds() {
            return __awaiter(this, void 0, void 0, function* () {
                if (!onChangeSelectedItemIds) {
                    return;
                }
                if (initialSelectedOrganizationIds === null || initialSelectedOrganizationIds === void 0 ? void 0 : initialSelectedOrganizationIds.length) {
                    const resolvedTreeItemIds = yield resolvedAnonymousTreeItem({
                        ids: initialSelectedOrganizationIds,
                    });
                    if (resolvedTreeItemIds) {
                        onChangeSelectedItemIds(() => resolvedTreeItemIds);
                    }
                }
                else {
                    onChangeSelectedItemIds(() => []);
                }
            });
        }
        fetchResolvedAnonymousTreeItemIds();
        // resolvedAnonymousTreeItem is a platform function and can not be included in dependency array
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initialSelectedOrganizationIds, onChangeSelectedItemIds]);
    const defaultDataTreeProps = Object.assign(Object.assign({}, dataTreeProps), { 'data-test': 'organization-tree', loading: dataTreeProps.loading });
    const selectedOrganizationIds = React.useMemo(() => {
        var _a;
        return (_a = dataTreeProps.selectedItemIds) === null || _a === void 0 ? void 0 : _a.map((id) => id.split('_')[0]);
    }, [dataTreeProps.selectedItemIds]);
    return {
        dataTreeProps: defaultDataTreeProps,
        filtersBarProps,
        appliedFilterData,
        reload,
        activeOrganizationId: (_a = dataTreeProps.activeItemId) === null || _a === void 0 ? void 0 : _a.split('_')[0],
        selectedOrganizationIds,
    };
}
